import React from 'react';

export const PortfolioModal = ({ selectedItem, setSelectedItem }) => {
  if (!selectedItem) return null;

  return (
    <div className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4" onClick={() => setSelectedItem(null)}>
      <div className="max-w-6xl w-full bg-slate-900 rounded-2xl overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="p-4 border-b border-slate-700 flex justify-between items-center">
          <h3 className="font-bold text-xl text-white">{selectedItem.title}</h3>
          <button onClick={() => setSelectedItem(null)} className="text-slate-400 hover:text-white text-3xl leading-none px-3">×</button>
        </div>
        <div className="bg-black p-4">
          {selectedItem.mediaType === 'photo' ? (
            <img src={selectedItem.url} alt={selectedItem.title} className="w-full max-h-[85vh] object-contain mx-auto rounded-xl" />
          ) : selectedItem.mediaType === 'embed' ? (
            <iframe src={selectedItem.url} className="w-full aspect-video rounded-xl" allowFullScreen title={selectedItem.title} allow="autoplay; fullscreen; picture-in-picture; xr-spatial-tracking" />
          ) : selectedItem.mediaType === 'pdf' ? (
            <iframe src={selectedItem.url} className="w-full h-[85vh] rounded-xl bg-white" title={selectedItem.title} />
          ) : null}
        </div>
      </div>
    </div>
  );
};
